var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuItemReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 18.563a.687.687 0 00.688.687h1.374a.687.687 0 00.688-.688v-8.25a.687.687 0 00-.688-.687h-1.374a.687.687 0 00-.688.688v8.25zm-3.438.687a.687.687 0 01-.687-.688v-5.5a.687.687 0 01.688-.687h1.374a.687.687 0 01.688.688v5.5a.687.687 0 01-.688.687h-1.374zm-4.124 0a.687.687 0 01-.688-.688v-2.75a.687.687 0 01.688-.687h1.375a.687.687 0 01.687.688v2.75a.687.687 0 01-.688.687H6.188z",
    fill: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 19.25V6.187L13.062 0H5.5a2.75 2.75 0 00-2.75 2.75v16.5A2.75 2.75 0 005.5 22h11a2.75 2.75 0 002.75-2.75zM13.062 4.125a2.062 2.062 0 002.063 2.063h2.75V19.25a1.375 1.375 0 01-1.375 1.375h-11a1.375 1.375 0 01-1.375-1.375V2.75A1.375 1.375 0 015.5 1.375h7.563v2.75z",
    fill: "#ED1B2E"
  })));
}

export default SvgIconMenuItemReport;